import React from "react";

import { HeroImageBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ButtonPrimary } from "../Clickables";
import { H, HLevel } from "../Headings";
import { getThemeClass } from "../ThemedModule";

import styles from "./HeroImage.module.scss";

interface Props {
    value: HeroImageBlock;
}

export const HeroImage = ({ value }: Props) => {
    return (
        <HLevel>
            <section
                className={concatClassNames([
                    styles.root,
                    getThemeClass(value.module_theme),
                ])}
            >
                {value.image && (
                    <div className={styles.image}>
                        <ImageChooserBlock value={value.image} attrs={{}} />
                    </div>
                )}

                <div className={styles.content}>
                    {value.eyebrow && (
                        <p className={styles.eyebrow}>{value.eyebrow}</p>
                    )}
                    {value.headline && (
                        <H className={styles.headline}>{value.headline}</H>
                    )}
                    {value.body && <p className={styles.body}>{value.body}</p>}
                    {value.cta?.display_name && (
                        <div className={styles.cta}>
                            <ButtonPrimary simpleLink={value.cta} />
                        </div>
                    )}
                </div>
            </section>
        </HLevel>
    );
};
